const SELECTOR_PLAYLIST_ITEM = ".js-playlist-item";

type ScrollPlaylistToLessonOptions = {
  behavior?: ScrollBehavior;
  offsetItems?: number;
};

export function scrollPlaylistToLesson(
  container: HTMLElement | null,
  lessonId: string,
  { behavior = "auto", offsetItems = 1 }: ScrollPlaylistToLessonOptions = {}
) {
  if (!container) return;

  const items = Array.from(
    container.querySelectorAll<HTMLElement>(SELECTOR_PLAYLIST_ITEM)
  );

  if (!items.length) return;

  const activeItem = container.querySelector<HTMLElement>(
    `[data-lesson-id='${lessonId}']`
  );

  if (!activeItem) return;

  const activeIndex = items.indexOf(activeItem);

  if (activeIndex < 0) return;

  const targetItem = items[Math.max(activeIndex - offsetItems, 0)];
  const containerRectTop = container.getBoundingClientRect().top;
  const targetRectTop = targetItem.getBoundingClientRect().top;
  const targetTop = targetRectTop - containerRectTop + container.scrollTop;

  container.scrollTo({
    top: targetTop,
    behavior,
  });
}
